<script setup lang="ts">
import { ref } from 'vue';
import { IS_DEBUG_MOCK } from '../api/psi';
import { useAirBulletin } from '../composables/useAirBulletin';
import { useMascotArtwork } from '../composables/useMascotArtwork';
const { previousDesign, currentTier, mascotState, reducedMotion, mascotReacting, feedStatus } =
  useAirBulletin();
const stage = ref<HTMLElement | null>(null);
const { art, paused } = useMascotArtwork(stage, mascotState, reducedMotion);
</script>

<template>
  <div ref="stage" class="mascot-stage" :class="{ 'motion-paused': paused }">
    <div class="stage-sun" aria-hidden="true"></div>
    <div class="stage-stamp">
      <template v-if="IS_DEBUG_MOCK">MOCK<br />DATA</template>
      <template v-else-if="previousDesign && feedStatus === 'fresh'">LIVE<br />FROM SG</template>
      <template v-else-if="previousDesign && feedStatus === 'stale'">LAST<br />READING</template>
      <template v-else-if="previousDesign">AWAITING<br />DATA</template>
      <template v-else-if="feedStatus === 'fresh'">SINGAPORE’S<br />RESIDENT DRAMA</template>
      <template v-else-if="feedStatus === 'stale'">LAST AVAILABLE<br />READING</template>
      <template v-else>AWAITING<br />NEA DATA</template>
    </div>
    <div v-if="previousDesign" class="stage-caption">
      <span>YOUR LOCAL HAZE-TER</span><span>EST. 2015</span>
    </div>
    <div class="mascot-art-frame" :class="{ 'mascot-reacting': mascotReacting }">
      <Transition name="mascot">
        <div
          v-if="art"
          :key="art.src"
          class="mascot-sprite-viewport"
          :data-state="art.state"
          role="img"
          :aria-label="art.alt"
        >
          <img
            :class="art.sheet ? 'mascot-sprite-sheet' : 'mascot-still'"
            :src="art.src"
            width="512"
            height="512"
            decoding="async"
            alt=""
            aria-hidden="true"
          />
        </div>
        <div
          v-else
          class="mascot-placeholder"
          role="img"
          :aria-label="
            mascotState === 'unknown'
              ? 'Air-quality status is not yet known.'
              : 'Merlion artwork is loading.'
          "
        >
          <svg class="waiting-icon" width="42" height="42" viewBox="0 0 48 48" aria-hidden="true">
            <path d="M6 16h26a5 5 0 1 0-5-5M6 24h34M6 32h21a5 5 0 1 1-5 5" />
          </svg>
          <span>{{
            mascotState === 'unknown' ? 'Waiting for the air report' : 'Your Merlion is on its way'
          }}</span>
        </div>
      </Transition>
    </div>
    <span v-if="previousDesign" class="haze-puff puff-a" aria-hidden="true"></span>
    <span v-if="previousDesign" class="haze-puff puff-b" aria-hidden="true"></span>
    <div v-else class="mascot-bubble">
      <span>{{ feedStatus === 'stale' ? 'last known status:' : 'status:' }}</span
      ><strong>{{ currentTier?.name ?? 'awaiting a reading' }}</strong>
    </div>
  </div>
</template>
